module.exports = __webpack_public_path__ + "static/media/web-application.d6226702.jpg";